import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import Header from './Header.jsx';
// import HeaderShopify from './HeaderShopify.jsx';
import Panel from './Panel.jsx';
import Board from './Board.jsx';
import BoardShopify from './BoardShopify.jsx';
import Login from './Login.jsx';
import Login2FA from './Login2FA.jsx';
// import { setOrders } from '../../redux/actions/orders';
import { withTranslation  } from 'react-i18next';
import i18n from "../../locales";
import SimpleBar from 'simplebar-react';

import 'simplebar-react/dist/simplebar.min.css';

const conditionalRendering = (props) => {
  if (props.login.access === false && props.login.access2FA === false) {
    console.log(`props.login => `, props.login);
    return (
      <Login />
    )
  } else if (props.login.access === true && props.login.access2FA === false) {
    console.log(`props.login => `, props.login);
    return (
      <Login2FA />
    )
  } else {
    if (props.login.shopify) {
      return (
        <div id="root2" className='boarderStyle'> 
          {/* <HeaderShopify /> */}
          {/* <Panel /> */}

          <SimpleBar autoHide={false} style={{ height: '100%' }}>
            <BoardShopify />
          </SimpleBar>
          
        </div>
      )
    } else {
      return (
        <div id="root2"> 
          <Header />
          <Panel />
          <Board />
        </div>
      )
    }
  }
}
export class App extends Component {
  useQuery() {
    return new URLSearchParams(window.location.search);
  }

  componentWillMount() {
    //this.props.dispatch(setOrders('jfarris'));
    const query = this.useQuery();
    if (!query.get("isLoginDirectly")) {
      document.getElementsByTagName('body')[0].style.backgroundImage = 'url("/wonderland_bgd.jpg")';
      document.getElementsByTagName('body')[0].style.animation = 'animatedBackground 150s linear infinite';
    }
    const languageFromUrl = query.get("lang") ? query.get("lang") : '';
    if (languageFromUrl) {
      localStorage.removeItem('language')
      localStorage.setItem('language', languageFromUrl);
      i18n.changeLanguage(languageFromUrl);
    } else {
      const locale = localStorage.getItem('language')
      if (locale) i18n.changeLanguage(locale);
    }
  }

  componentDidUpdate() {
    // if (this.props.login.shopify === true) {
    //   document.getElementsByTagName('body')[0].style.backgroundImage = 'url()';
    //   document.getElementsByTagName('body')[0].style.animation = 'none';
    // } else {
    //   document.getElementsByTagName('body')[0].style.backgroundImage = 'url("/wonderland_bgd.jpg")';
    //   document.getElementsByTagName('body')[0].style.animation = 'animatedBackground 150s linear infinite';
    // }
  }

  render() {
    return (
      <LoadingOverlay
        active={this.props.display.loadingOverlay.status}
        spinner
        text={this.props.display.loadingOverlay.text}
      >
        { conditionalRendering(this.props) }
      </LoadingOverlay>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    login: state.login,
    display: state.display,
    userID: state.userID
  }
}

export default connect(
  mapStateToProps
)(withTranslation()(App));



// WEBPACK FOOTER //
// ./src/js/containers/App.jsx